import { FileSharer } from "@byteowls/capacitor-filesharer";
import { isDefined } from "@clipboard-health/util-ts";
import { useToast } from "@src/appV2/lib";
import { useMutation } from "@tanstack/react-query";
import { domToPng } from "modern-screenshot";

import { type KnownInsightType } from "./Insight/types";

interface ShareResult {
  shared: boolean;
  error?: string;
}

export function useShareInsight() {
  const { showErrorToast } = useToast();

  return useMutation({
    mutationFn: async (insightType: KnownInsightType | undefined): Promise<ShareResult> => {
      try {
        if (!isDefined(insightType)) {
          return { shared: false };
        }

        const node = document.querySelector(`#${insightType}`);

        if (!isDefined(node)) {
          return { shared: false };
        }

        // find and show the share header for screenshot
        const shareHeader = node.querySelector(`#share-header`);
        shareHeader?.setAttribute("style", "opacity: 1;");

        const dataUrl = await domToPng(node, {
          width: window.innerWidth,
          height: window.innerHeight,
          drawImageInterval: 500,
        });

        // hide the share header after screenshot again
        shareHeader?.setAttribute("style", "opacity: 0;");

        // Extract base64 data from data URL (remove "data:image/png;base64," prefix)
        const base64Data = dataUrl.split(",")[1];

        await FileSharer.share({
          filename: "My 2025 Clipboard Health Mid-Year Recap.png",
          base64Data,
          contentType: "image/png",
        });

        return { shared: true };
      } catch (maybeError) {
        const error = maybeError as Error;

        showErrorToast("We couldn't share your insight ☹️ Please try again.");
        return {
          shared: false,
          error: error.message,
        };
      }
    },
  });
}
